/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {
  // Function to update the swatch placeholder on click
  function updateSwatchPlaceholder(swatchLink) {
    // Find the parent product-grid-item
    const productGridItem = swatchLink.closest("product-grid-item");
    if (!productGridItem) {
      return;
    }

    // Find the placeholder within the same product-grid-item
    const placeholder = productGridItem.querySelector(
      ".grid__swatch__placeholder",
    );
    if (!placeholder) {
      return;
    }

    // Get the color name from the swatch
    let colorName = "";

    // Try to get the name from the title attribute of the parent radio-swatch
    const radioSwatch = swatchLink.closest("radio-swatch");
    if (radioSwatch && radioSwatch.getAttribute("title")) {
      colorName = radioSwatch.getAttribute("title");
    } else {
      // If no title, try to get the text from span.visually-hidden
      const visuallyHidden = swatchLink.querySelector(".visually-hidden");
      if (visuallyHidden) {
        colorName = visuallyHidden.textContent.trim();
      } else {
        // Last resort: use the data-swatch attribute
        const dataSwatch = swatchLink.getAttribute("data-swatch");
        if (dataSwatch) {
          colorName = dataSwatch;
        }
      }
    }

    // Update the placeholder text if we found a color name
    if (colorName) {
      placeholder.textContent = colorName;
    }
  }

  // Event listener for clicks on swatch buttons
  document.addEventListener("click", function (event) {
    // Check if the click was on a swatch button with the class swatch__button--square
    const swatchLink = event.target.closest(
      ".swatch__button.swatch__button--square a",
    );
    if (swatchLink) {
      updateSwatchPlaceholder(swatchLink);
    }

    // Also handle clicks on sibling swatches (for related products)
    const siblingLink = event.target.closest(".siblings__link");
    if (siblingLink) {
      const productGridItem = siblingLink.closest("product-grid-item");
      if (productGridItem) {
        const placeholder = productGridItem.querySelector(
          ".grid__swatch__placeholder",
        );
        if (placeholder && siblingLink.getAttribute("title")) {
          const colorName = siblingLink.getAttribute("title");
          placeholder.textContent = colorName;
        }
      }
    }
  });

  // Run on page load
  document.addEventListener("DOMContentLoaded", function () {
    // Wait briefly for all elements to be rendered
    setTimeout(function () {
      initHeroVideo();
      initLazyVideoBackgrounds();
      initHeroProductFeatureVideoAudio();
    }, 100);
  });

  // Also run when the page is fully loaded
  window.addEventListener("load", function () {
    initHeroVideo();
    initLazyVideoBackgrounds();
    initHeroProductFeatureVideoAudio();
  });

  document.addEventListener("shopify:section:load", function () {
    initLazyVideoBackgrounds();
    initHeroProductFeatureVideoAudio();
  });

  function initHeroProductFeatureVideoAudio() {
    document
      .querySelectorAll(
        "[data-hero-video-audio-toggle]:not([data-audio-toggle-init])",
      )
      .forEach(function (button) {
        button.dataset.audioToggleInit = "true";

        button.addEventListener("click", function () {
          const section = button.closest(
            '[data-section-type="hero-product-feature"]',
          );
          if (!section) return;

          const muted = section.dataset.videoMuted !== "false";
          const nextMuted = !muted;

          section.dataset.videoMuted = nextMuted;
          button.setAttribute("aria-pressed", nextMuted ? "false" : "true");
          button.querySelector("[data-audio-label]").textContent = nextMuted
            ? "Unmute"
            : "Mute";
          button.querySelector("[data-icon-muted]").classList.toggle(
            "tw:hidden",
            !nextMuted,
          );
          button.querySelector("[data-icon-unmuted]").classList.toggle(
            "tw:hidden",
            nextMuted,
          );

          section
            .querySelectorAll("[data-lazy-video-bg]")
            .forEach(function (video) {
              video.muted = nextMuted;
              if (!nextMuted) {
                video.play().catch(function () {});
              }
            });
        });
      });
  }

  function initLazyVideoBackgrounds() {
    const videos = document.querySelectorAll(
      "[data-lazy-video-bg]:not([data-lazy-video-init])",
    );
    if (!videos.length) return;

    const loadVideo = (video) => {
      if (video.dataset.lazyVideoInit) return;
      video.dataset.lazyVideoInit = "true";

      const src = video.dataset.src;
      if (!src) return;

      video.src = src;
      video.load();

      video.addEventListener(
        "canplay",
        function () {
          const section = video.closest(
            '[data-section-type="hero-product-feature"]',
          );
          if (section && section.dataset.videoMuted === "false") {
            video.muted = false;
          }

          video.classList.add("is-loaded");
          video.play().catch(function () {});
        },
        { once: true },
      );

      video.addEventListener(
        "error",
        function () {
          video.removeAttribute("data-lazy-video-init");
        },
        { once: true },
      );
    };

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              loadVideo(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: "200px" },
      );

      videos.forEach(function (video) {
        observer.observe(video);
      });
    } else {
      videos.forEach(loadVideo);
    }
  }

  // Function to initialize the hero video
  function initHeroVideo() {
    console.log("🎬 Initializing hero video...");

    const heroVideos = document.querySelectorAll(".hero__video");

    heroVideos.forEach(function (video) {
      const desktopSrc = video.getAttribute("data-video-desktop");
      const mobileSrc = video.getAttribute("data-video-mobile");

      if (!desktopSrc) {
        console.log("❌ No desktop video found");
        return;
      }

      // Function to switch the video based on screen size
      function updateVideoSource() {
        const isMobile = window.innerWidth <= 768;
        const newSrc = isMobile && mobileSrc ? mobileSrc : desktopSrc;

        // Only change if the src is different
        if (video.src !== newSrc) {
          video.src = newSrc;
          video.load();
          console.log(
            "🔄 Video updated:",
            isMobile ? "mobile" : "desktop",
            newSrc,
          );
        }
      }

      // Set the initial video
      updateVideoSource();

      // Listen for window resize changes
      let resizeTimeout;
      window.addEventListener("resize", function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(updateVideoSource, 250);
      });

      // Handle video errors
      video.addEventListener("error", function (e) {
        console.error("❌ Error loading video:", e);
      });
    });
  }

  // Function to update cart badges
  function updateCartBadges(cart) {
    if (!cart) return;

    const itemCount = cart.item_count || 0;

    // Find all cart icon containers
    const cartIconWrappers = document.querySelectorAll(
      ".navlink--cart__icon-wrapper",
    );

    cartIconWrappers.forEach(function (iconWrapper) {
      let badge = iconWrapper.querySelector("[data-header-cart-count-badge]");

      if (itemCount > 0) {
        // If there are items, create the badge if it doesn't exist
        if (!badge) {
          badge = document.createElement("span");
          badge.className = "navlink--cart__badge";
          badge.setAttribute("data-header-cart-count-badge", itemCount);
          iconWrapper.appendChild(badge);
        }

        // Update the badge content
        badge.setAttribute("data-header-cart-count-badge", itemCount);
        badge.textContent = itemCount;
        badge.style.display = "";
      } else {
        // If there are no items, remove the badge if it exists
        if (badge) {
          badge.remove();
        }
      }
    });
  }

  document.addEventListener("theme:cart:change", function (event) {
    var cart = event.detail.cart;
    if (cart) {
      updateCartBadges(cart);
    }
  });

  // Update badges when the cart is initialized
  document.addEventListener("theme:cart:init", function (e) {
    if (e && e.detail && e.detail.cart) {
      updateCartBadges(e.detail.cart);
    } else {
      // Get the current cart from the API
      fetch(window.theme?.routes?.cart + ".js")
        .then((response) => response.json())
        .then((cart) => {
          updateCartBadges(cart);
        })
        .catch((error) => {
          console.error("Error fetching cart:", error);
        });
    }
  });

  // Also update badges on page load (just in case)
  document.addEventListener("DOMContentLoaded", function () {
    // Wait briefly for the theme to initialize
    setTimeout(function () {
      if (window.theme && window.theme.routes) {
        fetch(window.theme.routes.cart + ".js")
          .then((response) => response.json())
          .then((cart) => {
            updateCartBadges(cart);
          })
          .catch((error) => {
            console.error("Error fetching initial cart:", error);
          });
      }
    }, 500);
  });
  // Fired when page loads to update header values
  document.addEventListener("theme:cart:init", (e) => {
    console.log(e);
  });
})();

//Handle discount code buttons in announcement bars

document.addEventListener("click", function (e) {
  const btn = e.target.closest(".randr-discount-trigger");
  if (!btn || btn.dataset.applying) return;

  const code = btn.dataset.discountCode;
  if (!code) return;

  btn.dataset.applying = true;

  fetch("/discount/" + encodeURIComponent(code), { credentials: "same-origin" })
    .then(() =>
      showToast(btn.dataset.successText || "Discount applied! 🎉", true),
    )
    .catch(() =>
      showToast(btn.dataset.errorText || "Error applying discount", false),
    )
    .finally(() => delete btn.dataset.applying);
});

function showToast(message, success) {
  const toast = Object.assign(document.createElement("div"), {
    textContent: message,
    style: `
      position: fixed; top:120px; left: 50%; transform: translateX(-50%);
      background: ${success ? "#111" : "#c0392b"}; color: #fff;
      padding: .65rem 1.25rem; border-radius: 999px; font-size: .875rem;
      box-shadow: 0 4px 16px rgba(0,0,0,.2); z-index: 9999;
      animation: fadeInUp .25s ease; white-space: nowrap;
    `,
  });

  const style = document.createElement("style");
  style.textContent = `@keyframes fadeInUp { from { opacity:0; transform:translateX(-50%) translateY(8px) } to { opacity:1; transform:translateX(-50%) translateY(0) } }`;
  document.head.appendChild(style);

  document.body.appendChild(toast);
  setTimeout(() => toast.remove(), 3000);
}

// Open cart drawer instead of popdown when item is added to cart
document.addEventListener("theme:cart:popdown", function (e) {
  e.stopImmediatePropagation();
  const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
  if (cartDrawer) {
    cartDrawer.dispatchEvent(new CustomEvent("theme:drawer:open", { bubbles: false }));
    // Force a fresh /cart.js fetch (theme:cart:init triggers init() which fires theme:cart:change).
    // Once the fresh data is in this.cart, dispatch reload so loadForm() re-renders the drawer.
    // This fixes the case where this.cart was cached as empty (item_count: 0), which would
    // cause loadHTML() to call showEmpty() instead of loadForm() and never fetch fresh content.
    document.addEventListener("theme:cart:change", function () {
      document.dispatchEvent(new CustomEvent("theme:cart:reload", { bubbles: true }));
    }, { once: true });
    document.dispatchEvent(new CustomEvent("theme:cart:init", { bubbles: true }));
  }
}, true);

// Embroidery cart sync. Added Oct 6, 2026 (Sydney).
// The embroidery add-on puts two lines in the cart: the item (property _pair)
// and the embroidery line (properties _for and _pair). Rebuy's cart does not
// know they belong together, so removing the item left the embroidery behind.
// After any cart change, this removes embroidery lines whose paired item is gone.
// It only touches lines that carry both _for and _pair.
(function () {
  if (window.__rrEmbroiderySync) return;
  window.__rrEmbroiderySync = true;

  var busy = false;
  var timer = null;
  var origFetch = window.fetch.bind(window);
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  function isCartChange(url) {
    return /\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(String(url || ""));
  }

  function refreshCartUi(cart) {
    document.dispatchEvent(new CustomEvent("theme:cart:change", { detail: { cart: cart }, bubbles: true }));
    try {
      if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.fetchCart === "function") {
        window.Rebuy.Cart.fetchCart();
      }
    } catch (e) {}
    if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
  }

  function sync() {
    if (busy) return;
    busy = true;
    origFetch(root + "cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var parents = {};
        cart.items.forEach(function (item) {
          var p = item.properties || {};
          if (p._pair && !p._for) parents[p._pair] = true;
        });
        var updates = {};
        var count = 0;
        cart.items.forEach(function (item) {
          var p = item.properties || {};
          if (p._for && p._pair && !parents[p._pair]) {
            updates[item.key] = 0;
            count++;
          }
        });
        if (!count) return null;
        return origFetch(root + "cart/update.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ updates: updates })
        })
          .then(function (r) { return r.json(); })
          .then(refreshCartUi);
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 400);
  }

  window.fetch = function (input) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    var request = origFetch.apply(window, arguments);
    if (!busy && isCartChange(url)) request.then(schedule, function () {});
    return request;
  };

  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__rrUrl = url;
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (!busy && isCartChange(this.__rrUrl)) this.addEventListener("load", schedule);
    return xhrSend.apply(this, arguments);
  };

  document.addEventListener("rebuy:cart.change", schedule);
  schedule();
})();
